import script from "./ProductPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ProductPanel.vue?vue&type=style&index=0&id=12072d58&lang=scss&scoped=true"
import "./ProductPanel.vue?vue&type=style&index=1&id=12072d58&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12072d58"]])

export default __exports__